import { v4 as uuid } from 'uuid';

import { RULE_TYPE } from 'yeself-common/enum/RuleEnum';
import {
    DoNotStartAutomaticallyRuleDefinition,
    RuleId,
    RulesDefinitions,
    RulesDefinitionsItem,
} from 'yeself-common/typings/Rules';

const findDoNotStartAutomaticallyRule = (rule: RulesDefinitionsItem) =>
    rule.type === RULE_TYPE.DO_NOT_START_AUTOMATICALLY;

const createDoNotStartAutomaticallyRule = (): DoNotStartAutomaticallyRuleDefinition => ({
    id: uuid() as RuleId,
    type: RULE_TYPE.DO_NOT_START_AUTOMATICALLY,
    level: [],
    assignments: [],
});

export const doNotStartAutomaticallyRuleFilter = (rule: RulesDefinitionsItem) =>
    rule.type !== RULE_TYPE.DO_NOT_START_AUTOMATICALLY;

export const appendDoNotStartAutomaticallyRule = (rules: RulesDefinitions): RulesDefinitions => {
    const { identity, visitor } = rules;

    if (!visitor.find(findDoNotStartAutomaticallyRule)) {
        visitor.push(createDoNotStartAutomaticallyRule());
    }

    if (!identity.find(findDoNotStartAutomaticallyRule)) {
        identity.push(createDoNotStartAutomaticallyRule());
    }

    return { identity, visitor };
};

export const filterDoNotStartAutomaticallyRule = (rules: RulesDefinitions): RulesDefinitions => ({
    identity: rules.identity.filter(doNotStartAutomaticallyRuleFilter),
    visitor: rules.visitor.filter(doNotStartAutomaticallyRuleFilter),
});
